module.exports = __webpack_public_path__ + "static/year_landscape-d209130fb9e46705bb8889e9adea8b5f.png";